var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactCardArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#484848",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.707 764.707l-4-4c-.39-.39-1.024-.39-1.414 0-.39.39-.39 1.024 0 1.414l2.293 2.293H36c-.552 0-1 .448-1 1s.448 1 1 1h7.586l-2.293 2.293c-.39.39-.39 1.024 0 1.414.39.39 1.024.39 1.414 0l4-4c.39-.39.39-1.024 0-1.414z",
    transform: "translate(-35 -760)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactCardArrow);
export default __webpack_public_path__ + "static/media/contactCardArrow.748e62ef6d2e8dcdb2b44a6d2b5b1105.svg";
export { ForwardRef as ReactComponent };